// The guardrails' outcome as a refusal carries it to a caller
// (02-DESIGN/07-guardrails/01-rules-and-enforcement.md § the outcome on the
// wire; decision 0083 § 6): the headers are the carrier and the message is for
// people, so the escalation id is read from Impire-Guard-Escalation, and the
// message's first word is only the fallback for a refusal read without its
// headers. The Go library's guard package, the part a client reads.
import { ServiceError } from "./envelope.js";
import { validToken } from "./subject.js";
/** HEADER_OUTCOME is `allow`, `deny`, `escalate` or `transform`, on every reply an enforcement point sends. */
export const HEADER_OUTCOME = "Impire-Guard-Outcome";
/** HEADER_RULE is `<id>@<revision>` of the deciding rule, or `none`. */
export const HEADER_RULE = "Impire-Guard-Rule";
/** HEADER_ESCALATION carries the escalation id on a `guard-escalated` refusal. */
export const HEADER_ESCALATION = "Impire-Guard-Escalation";
/** CODE_ESCALATED is a terminal escalation; the escalation id leads the message. */
export const CODE_ESCALATED = "guard-escalated";
/** validID reports whether id is one subject token and none of the family's own words. */
export function validID(id) {
    return validToken(id) && id !== "list" && id !== "watch" && id !== "keys";
}
/**
 * escalationOf reads the escalation id off a refusal: from
 * Impire-Guard-Escalation, else — a `guard-escalated` refusal read without its
 * headers — from the message's first word, as the gateway does. A value that
 * is not a well-formed id is no id. Undefined for anything else.
 */
export function escalationOf(err) {
    if (!(err instanceof ServiceError)) {
        return undefined;
    }
    const header = err.headers?.get(HEADER_ESCALATION) ?? "";
    if (validID(header)) {
        return header;
    }
    if (err.code !== CODE_ESCALATED) {
        return undefined;
    }
    const word = err.message.split(" ", 1)[0] ?? "";
    return validID(word) ? word : undefined;
}
//# sourceMappingURL=guard.js.map